import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { FileSelectEvent } from 'primeng/fileupload';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrl: './image-cropper.component.css'
})
export class ImageCropperComponent implements OnInit {

  constructor() { }

  @Input('label') label: string = "Seleziona un'immagine";
  @Input('accept') accept: string = '';
  @Input('type') type: string = '';
  @Input('width') width: number = 0;
  @Input('height') height: number = 0;
  @Input('aspect_ratio') aspect_ratio: number = 0;

  @Output() onCrop = new EventEmitter<string>();

  cropImgPreview: string | any = '';
  immagineFile?: File | null;

  resize_width: number = 0;
  resize_height: number = 0

  ngOnInit(): void {
  }

  cropImg(e: ImageCroppedEvent) {

    this.blobToBase64(e.blob!).then(data => {
      this.cropImgPreview = data;
      this.onCrop.emit(this.cropImgPreview.toString());
    })

  }

  blobToBase64(blob: Blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  getImageDimensions(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        if (event.target?.result) {
          resolve(reader.result as string);
        }
      };
      reader.onerror = (error) => { reject(error); };
      reader.readAsDataURL(file);
    });
  }

  onImmagineUpload(event: FileSelectEvent) {

    if (event.currentFiles.length > 0) {
      const image = event.currentFiles[0];
      this.getImageDimensions(image).then(data => {
        this.immagineFile = image;
      })
    }

  };

  onRemoveImmagineUpload(event: any) {
    this.immagineFile = null;
    this.onCrop.emit('');
  }

}